import React from 'react';

import './highlight.css'

const Highlight = ({ content }) => {
    return  (
        <div className = "highlight">
            <div className="nub" />
            <p>{content}</p>
            <div className="nub inverted" />
        </div>
    );
}

export default Highlight;